export default __webpack_public_path__ + "c6.png";